import React from "react";
import FirstCategoryPage from "src/components/FirstCategoryPage/FirstCategoryPage";
import { GetStaticProps } from "next";
import { MetaDataPage, MetaDataPageType } from "src/models/meta/getMetaData";
import { requestCategoryPage } from "src/utils/helpers/requestApi/serverFetchPage/requestCategoryPage";
import MetaContainer from "src/components/common/Layout/components/MetaContainer/MetaContainer";
import { SubcategoriesSchema } from "src/models/category/getSubcategories";
import { brandsAbcSchema } from "src/models/brandsAbc/getBrandsAbc";
import { CatalogListItemsCategorySchema } from "src/models/category/getCategory";

export interface CategoryProps {
  subcategories: SubcategoriesSchema[];
  brandsAbc: brandsAbcSchema;
  categoryHtmlText: CatalogListItemsCategorySchema;
}

const Category: React.FC<CategoryProps & MetaDataPage> = ({
  metaData,
  subcategories,
  brandsAbc,
  categoryHtmlText,
}) => {
  return (
    <MetaContainer {...metaData}>
      <FirstCategoryPage
        pageTitle={metaData?.h1}
        subcategories={subcategories}
        brandsAbc={brandsAbc}
        categoryHtmlText={categoryHtmlText}
      />
    </MetaContainer>
  );
};

export const getStaticPaths = async () => {
  return {
    paths: [
      {
        params: {
          category: "lekarstva",
          city: "moskva",
        },
      },
    ],
    fallback: "blocking",
  };
};

export const getStaticProps: GetStaticProps = requestCategoryPage.bind(
  null,
  MetaDataPageType.catalogMainCategory
);

export default Category;
